// Static content data for Marez Detailing

export const BUSINESS = {
  name: "Marez Detailing",
  tagline: "Premium Auto Care",
  location: "Newark, CA",
  address: "8331 Mayhews Landing Rd, Newark, CA 94560",
  serving: "Serving Newark, Fremont, and the Bay Area",
  phone: "(510) 303-0544",
  phoneRaw: "+15103030544",
  owner: "Matthew Marez",
  instagram: "marezdetailing",
  instagramUrl: "https://instagram.com/marezdetailing",
  booksyUrl:
    "https://booksy.com/en-us/1496372_marez-detailing_professional-services_103682_newark",
  rating: "5.0",
  reviewsCount: 5,
};

export const SERVICES = [
  {
    id: "presidential-detail",
    title: "Presidential Detail",
    desc: "Our flagship. Clay bar, iron decon, 18-month ceramic sealant, deep interior clean & shampoo.",
    price: "$310",
    duration: "3h 50min",
    span: "md:col-span-7",
    image: "/showcase_corvette.jpg",
  },
  {
    id: "deluxe-detail",
    title: "Deluxe Detail",
    desc: "Hand wash, wax/sealant, wheels & tires, trim restoration, and full interior steam detail.",
    price: "$195",
    duration: "3h 30min",
    span: "md:col-span-5",
    image: "/interior_detail.jpg",
  },
  {
    id: "interior-detail",
    title: "Interior Detail",
    desc: "Deep vacuum, steam extraction, leather conditioning, surfaces dressed, odor elimination.",
    price: "from $100",
    duration: "1h 50min",
    span: "md:col-span-5",
    image: "/showcase_bmw_interior.jpg",
  },
  {
    id: "exterior-detail",
    title: "Exterior Detail",
    desc: "Hand wash, light clay bar, wax/sealant, wheels & tires, glass — a deep glossy finish.",
    price: "from $90",
    duration: "1h 30min",
    span: "md:col-span-7",
    image: "/exterior_after.jpg",
  },
  {
    id: "maintenance-detail",
    title: "Maintenance Detail",
    desc: "Every 4 weeks — keep that just-detailed look between full services.",
    price: "Varies",
    duration: "2h 30min",
    span: "md:col-span-4",
  },
  {
    id: "basic-washes",
    title: "Basic Washes",
    desc: "Quick exterior or interior refresh, priced by vehicle size.",
    price: "from $25",
    duration: "35min",
    span: "md:col-span-4",
  },
  {
    id: "basic-wash-combo",
    title: "Basic Wash Combo",
    desc: "Exterior + interior in one pass — wash, dry, vacuum, and windows.",
    price: "from $65",
    duration: "1h 10min",
    span: "md:col-span-4",
  },
];

export const WHY_CHOOSE = [
  {
    title: "Premium Results",
    desc: "Show-quality finishes that exceed expectations every time.",
  },
  {
    title: "Careful Attention to Detail",
    desc: "We treat every panel, seam, and stitch with obsessive care.",
  },
  {
    title: "Trusted by Local Car Owners",
    desc: "A growing base of loyal Bay Area clients who keep coming back.",
  },
  {
    title: "Built for Every Vehicle",
    desc: "Perfect for daily drivers, luxury cars, and exotics alike.",
  },
  {
    title: "Easy Booking",
    desc: "Reserve your appointment in under a minute, hassle free.",
  },
];

export const COMPARE_GALLERY = [
  {
    before: "/porsche-gt3rs-foam-wash.webp",
    after: "/porsche-gt3rs-finished.webp",
    label: "Porsche 911 GT3 RS — Foam Wash & Final Finish",
    objectPosition: "center 68%",
  },
  {
    before: "/exterior_before.jpg",
    after: "/exterior_after.jpg",
    label: "Corvette — Foam Wash & Gloss Restoration",
  },
  {
    before: "/crv_before.jpg",
    after: "/crv_after.jpg",
    label: "Honda CR-V — Full Exterior Wash",
  },
];

export const SHOWCASE_GALLERY = [
  { image: "/bugatti-mansory-exterior.webp", label: "Bugatti Mansory 1 of 1", tag: "Exterior" },
  { image: "/bugatti-mansory-interior.webp", label: "Bugatti Mansory 1 of 1", tag: "Interior" },
  { image: "/ferrari-f40.webp", label: "Ferrari F40", tag: "Exterior" },
  { image: "/ford-f150-finished.webp", label: "Ford F-150 Platinum", tag: "Exterior" },
  { image: "/luxury-interior-finished.webp", label: "Luxury Rear Cabin", tag: "Interior" },
  { image: "/show_lambo_yellow.jpg", label: "Lamborghini Huracán", tag: "Exterior" },
  { image: "/show_corvette_blue.jpg", label: "Corvette C8", tag: "Exterior" },
  { image: "/show_lambo_wheel.jpg", label: "Lamborghini Huracán", tag: "Interior" },
  { image: "/showcase_mclaren.jpg", label: "McLaren 600LT", tag: "Exterior" },
  { image: "/show_lambo_performante.jpg", label: "Huracán Performante", tag: "Interior" },
  { image: "/show_tacoma_spoiler.jpg", label: "Huracán ALA Wing", tag: "Exterior" },
  { image: "/showcase_corvette.jpg", label: "Corvette Z06", tag: "Exterior" },
  { image: "/show_lambo_door.jpg", label: "Huracán Cabin", tag: "Interior" },
  { image: "/show_tacoma_foam.jpg", label: "Huracán Foam Wash", tag: "Exterior" },
  { image: "/interior_detail.jpg", label: "Lamborghini Huracán", tag: "Interior" },
  { image: "/showcase_bmw_interior.jpg", label: "BMW M-Series Cabin", tag: "Interior" },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);

export const CONDITION_OPTIONS = [
  "Like New",
  "Lightly Used",
  "Moderately Dirty",
  "Heavily Soiled",
  "Needs Restoration",
];

export const MEMBERSHIP_PLANS = [
  {
    num: "01",
    name: "Basic Wash",
    price: "$40",
    cadence: "Once a month",
    popular: false,
    features: [
      "Hand wash & dry",
      "Light interior vacuum",
      "Interior wipe-down (dash, console, doors)",
      "Windows cleaned",
      "Tire shine",
    ],
  },
  {
    num: "02",
    name: "Clean & Protect",
    price: "$70",
    cadence: "Twice a month",
    popular: true,
    features: [
      "Full hand wash & dry",
      "Interior vacuum (seats, floors)",
      "Interior wipe-down",
      "Interior windows",
      "Tire & trim shine",
      "Spray wax (once a month)",
    ],
  },
  {
    num: "03",
    name: "Full Care",
    price: "$100",
    cadence: "Twice a month",
    popular: false,
    features: [
      "Full wash & dry",
      "Full interior vacuum",
      "All interior surfaces cleaned & protected",
      "Interior & exterior windows",
      "Wheels cleaned & dressed",
      "Spray wax or ceramic topper (monthly)",
    ],
  },
];

export const ABOUT = {
  heading: "About Marez",
  image: "/showcase_mclaren.jpg",
  rating: "5.0",
  ratingLabel: "Client Rating",
  paragraphs: [
    "I'm the founder and sole detailer behind Marez Detailing — a premium auto detailing studio based in Newark, CA, serving the greater Bay Area. What started as a personal obsession with clean cars has evolved into a precision-focused detailing practice trusted by supercar owners, daily drivers, and everyone in between.",
    "I built Marez on a simple belief: every vehicle deserves to be treated like a work of art. That means no rushed jobs, no cutting corners, and no compromising on the products I use or the results I deliver.",
    "Whether it's a full detail on an exotic or a deep interior revival on your daily driver, I bring the same level of care and craftsmanship to every appointment. This isn't a side hustle — it's my craft.",
  ],
};

export const TESTIMONIALS = [
  {
    name: "Ruben Sanchez-Donate",
    car: "Loyal Customer · Google Review",
    quote:
      "Great service and incredible attention to detail. Marez Detailing is the only service we’ve used since getting our car at the beginning of 2026. We recommend Matthew to everyone—his work consistently meets and exceeds our expectations.",
  },
  {
    name: "Brian",
    car: "Local Customer · Google Review",
    quote:
      "It’s great to see a young, driven professional who pays attention to every little detail. I really appreciate the cold water bottle and neatly folded towel waiting in the car whenever I pick it up. A great local option!",
  },
  {
    name: "Anirudh Reddy",
    car: "Ford Mustang · Full Detail",
    quote:
      "Outstanding job detailing my Ford Mustang! Matthew was punctual, professional, and maintained great communication throughout the appointment. The car was ready on time and looked new inside and out. Highly recommend Marez Detailing.",
  },
  {
    name: "Manuel",
    car: "Exterior Detail",
    quote:
      "Marez did a really good job detailing my car. My car smells fresh and the exterior looks amazing — so shiny when it reflects in the sun. My calipers were very dirty and now I see them clearly. I recommend Marez for sure!",
  },
  {
    name: "Ashley",
    car: "Interior Detail",
    quote: "Great customer service. My car looks and feels brand new inside.",
  },
];
